import { useEffect, useRef } from 'react';

// Banyak user tidak sengaja menekan tombol back browser / gesture back HP saat
// sedang mengerjakan tes (latihan harian maupun tryout), sehingga keluar dari
// halaman sebelum selesai dan hasilnya tidak sempat tersimpan/terkirim ke server.
//
// Hook ini dipasang selama fase "sedang mengerjakan" saja (bukan di layar
// intro/pengaturan, dan bukan di layar hasil — karena skor di layar hasil
// sudah tercatat). Selama aktif:
//   1) Tombol back browser / gesture back HP ditangkap lebih dulu (lewat trik
//      history.pushState + popstate) dan memunculkan konfirmasi "yakin keluar?"
//      alih-alih langsung keluar dari halaman.
//   2) Menutup/refresh tab juga dicegat lewat beforeunload (browser akan
//      menampilkan dialog konfirmasi bawaannya sendiri).
//
// @param {boolean} aktif - true selama user sedang mengerjakan tes (progres belum tersimpan)
// @param {Function} onKeluarDikonfirmasi - dipanggil kalau user MEMILIH untuk tetap keluar
export function useCegahKeluarTes(aktif, onKeluarDikonfirmasi) {
  const sedangKonfirmasiRef = useRef(false);

  useEffect(() => {
    if (!aktif) return undefined;

    sedangKonfirmasiRef.current = false;
    // dipakai buat tahu apakah entry dummy di bawah ini sudah "terpakai" oleh
    // navigasi back beneran (lewat handlePopState) atau belum — dicek lagi di
    // cleanup supaya tidak nyangkut kalau tesnya selesai dengan normal.
    let historyDikonsumsi = false;
    window.history.pushState({ cegahKeluarTes: true }, '');

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    const handlePopState = () => {
      if (sedangKonfirmasiRef.current) return;
      sedangKonfirmasiRef.current = true;
      const yakinKeluar = window.confirm(
        'Yakin ingin keluar? Tes belum selesai — progresmu akan disimpan otomatis di perangkat ini, jadi kamu bisa lanjutkan dari titik terakhir kalau kembali lagi nanti.'
      );
      if (yakinKeluar) {
        historyDikonsumsi = true;
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handlePopState);
        if (onKeluarDikonfirmasi) onKeluarDikonfirmasi();
      } else {
        // Batal keluar — tahan lagi di halaman ini.
        window.history.pushState({ cegahKeluarTes: true }, '');
        sedangKonfirmasiRef.current = false;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      // Kalau hook ini berhenti aktif BUKAN karena user menekan back (mis. tes
      // diselesaikan dengan normal sampai ke layar hasil), entry dummy yang
      // dipush di atas masih nyangkut di history browser. Kalau dibiarkan,
      // makin banyak modul yang dikerjakan makin banyak entry dummy menumpuk,
      // sehingga user perlu menekan tombol back berkali-kali untuk benar-benar
      // keluar. Buang entry itu di sini supaya history tetap bersih.
      if (!historyDikonsumsi) {
        window.history.back();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aktif]);
}
